{
  "dropzoneLabel": "DropZone",
  "selectPlaceholder": "Vælg et element",
  "tableResizer": "Størrelsesændring",
  "colorSwatchPicker": "Color swatches"
}
